import React, { useState } from 'react';

const TreeNode = ({ node, onAgentClick, onSelectNode }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  

  // Переключение видимости подветок
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  // Убедимся, что `children` всегда массив
  const children = node.children || [];
  const agents = node.agents || [];

  return (
    <div style={{ marginLeft: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div
          onClick={() => {
            toggleExpand();
            onSelectNode(node); // Передаем выбранный узел в родительский компонент
          }}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          {(children.length > 0 || agents.length > 0) && (
            <span style={{ marginRight: 5 }}>{isExpanded ? '▼' : '▶'}</span>
          )}
          {node.name}
        </div>
      </div>

      {isExpanded && (
        <div>
          {agents.map(agent => (
            <div key={agent.id} onClick={() => onAgentClick(agent.id)} style={{ marginLeft: 20, cursor: 'pointer' }}>
              🛠️ {agent.name}
            </div>
          ))}
          {children.map(child => (
            <TreeNode
              key={child.id}
              node={child}
              onAgentClick={onAgentClick}
              onSelectNode={onSelectNode} // Передаем функцию выбора узла
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TreeNode;
